// src/hooks/programs/useConvertProgramCurrency.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { convertProgramCurrency } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useConvertProgramCurrency = () => {
    const queryClient = useQueryClient();

    const {
        mutate: convertCurrencyMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, currencyId }) => convertProgramCurrency(id, currencyId),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
            queryClient.invalidateQueries({ queryKey: ["program"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to convert currency");
        },
    });

    return {
        convertCurrencyMutate,
        isPending: isPending || isLoading,
    };
};

export default useConvertProgramCurrency;